import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from '../components/dashboard-card';
import DashboardTitle from '../components/dashboard-title';
import MLWeatherWidget from './ml-widget';

export default function WeatherWidget() {
  const { t } = useTranslation();

  return (
    <DashboardCard>
      <DashboardTitle title={t('pages.dashboard.weather.heading')} />

      <MLWeatherWidget />
    </DashboardCard>
  );
}
